module.exports = __webpack_public_path__ + "img/Nueva propuesta P2H 1.0-16.f9d47327.svg";